import React from "react";

const ImageGridCard = ({ item, styles }) => {
  const baseUrl = process.env.REACT_APP_API_URL;
  const coloum_value = JSON.parse(item?.coloum_value);

  return (
    <div>
      <div className="grid grid-cols-2 gap-[11px] ">
        {coloum_value?.map((image, i) => {
          return (
            <div key={i}>
              <img
                src={`${image ? baseUrl + "/profile/" + image : ""}`}
                className=" min-w-[125px] min-h-[125px] w-[125px] h-[125px] max-w-[125px] max-h-[125px] rounded-lg object-cover"
                alt="..." title="Image" 
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ImageGridCard;
